















import { IconSize } from '@getaccept/lib-ui';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '../../helpers/translation.helper';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const text = computed(() =>
      props.value ? t('Hide Ghost comments') : t('Show Ghost comments')
    );

    return { IconSize, text };
  },
});
